module.exports = __webpack_public_path__ + "media/printed-materials/image024-91d44ad9.jpg";